import { apiClient } from '@/lib/api/api-client';
import { ENDPOINTS } from '@/lib/api/endpoints';
import {
  SalesProfile,
  SalesProfileUpdate,
  SalesExample,
  CreateExampleData,
  UpdateExampleData,
  SalesExampleCategory,
} from '../types/sales-training.types';

class SalesTrainingService {
  async getProfile(): Promise<SalesProfile | null> {
    return apiClient.get<SalesProfile | null>(ENDPOINTS.SALES_TRAINING_PROFILE);
  }

  async updateProfile(data: SalesProfileUpdate): Promise<SalesProfile> {
    return apiClient.put<SalesProfile>(ENDPOINTS.SALES_TRAINING_PROFILE, data);
  }

  async getExamples(category?: SalesExampleCategory): Promise<SalesExample[]> {
    const params = category ? `?category=${category}` : '';
    return apiClient.get<SalesExample[]>(`${ENDPOINTS.SALES_TRAINING_EXAMPLES}${params}`);
  }

  async createExample(data: CreateExampleData): Promise<SalesExample> {
    return apiClient.post<SalesExample>(ENDPOINTS.SALES_TRAINING_EXAMPLES, data);
  }

  async updateExample(id: string, data: UpdateExampleData): Promise<SalesExample> {
    return apiClient.put<SalesExample>(ENDPOINTS.SALES_TRAINING_EXAMPLE_BY_ID(id), data);
  }

  async deleteExample(id: string): Promise<void> {
    return apiClient.delete<void>(ENDPOINTS.SALES_TRAINING_EXAMPLE_BY_ID(id));
  }
}

export const salesTrainingService = new SalesTrainingService();
export default salesTrainingService;
